import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import {HandleReactComponentRendering} from '@ClientBase/React/RenderReactComponents'
import {declareClientPackage, RuntimeDetails} from "@ClientBase/IClientPackage";
import { JobFiltersEventHandler } from "@ClientBase/Generic/JobFiltersEventHandler";
import { PostFiltersEventHandler } from "@ClientBase/Generic/PostFiltersEventHandler";
import { BurgerMenuEventHandler } from "@ClientBase/Generic/BurgerMenuEventHandler";
import { CreateCarousels } from "./CarouselsNew";
import * as DomMainipulations from "./DomMainipulations";
import * as Navigation from "./Navigation";
import * as Filters from "./Filters";
import * as Modal from "./Modal";
import * as BannerApi from "./BannerApi";
import * as HomepageSearch from "./HomepageSearch";
import * as JobFilters from "./JobFilters";
import * as SearchOverlay from "./SearchOverlay";
import * as JobResults from "./JobResults";
import * as Pagination from "./Pagination";
import * as JobsNearYou from "./JobsNearYou";
import * as ListWidget from "./ListWidget";
import * as Cookie from "./Cookie";
import * as VacancyButtons from "./VacancyButtons";

//snippets
import {SnippetContent} from "./Content/Content";
import {SnippetSpacer} from "./Spacer/Spacer";
import { SnippetImageAndTextBackground } from 'ImageAndTextColourBackground/ImageAndTextColourBackground';
import {SnippetJobAd} from "./JobAd/JobAd";
import  {SnippetImageAndTextButtons}  from './ImageAndTextButtons/ImageAndTextButtons';
import {SnippetImageBlock} from './ImageBlock/ImageBlock';
import {SnippetImageAndTextHeadline} from './ImageAndTextHeadline/ImageAndTextHeadline';
import  {SnippetParagraph} from './Paragraph/Paragraph';
import {SnippetHeading} from './Heading/Heading';
import {SnippetButtons} from './Buttons/Buttons';
import {SnippetImageAndText} from './ImageAndText/ImageAndText';
import {SnippetAccordion} from './Accordion/Accordion';

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    SnippetSpacer: SnippetSpacer,
    SnippetContent: SnippetContent,
    SnippetImageAndTextBackground: SnippetImageAndTextBackground,
    SnippetJobAd: SnippetJobAd,
    SnippetImageAndTextButtons: SnippetImageAndTextButtons,
    SnippetImageBlock: SnippetImageBlock,
    SnippetImageAndTextHeadline: SnippetImageAndTextHeadline,
    SnippetParagraph: SnippetParagraph,
    SnippetHeading: SnippetHeading,
    SnippetButtons: SnippetButtons,
    SnippetImageAndText: SnippetImageAndText,
    SnippetAccordion: SnippetAccordion,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.navigationFunctions();
        DomMainipulations.removeSocialWidgetIfEmpty();
        JobFiltersEventHandler.useAttraxTsHandlers($);
        PostFiltersEventHandler.useAttraxTShandler($);
        BurgerMenuEventHandler.handleClickEvents($);
        DomMainipulations.homePageScroll($);
        DomMainipulations.shortlistRedirect($);
        DomMainipulations.showValidationIfTrue($);
        DomMainipulations.removeFooterAutocomplete($);
        
        DomMainipulations.showExpiredVacancyBanner($);
        DomMainipulations.addClearbtn();
        DomMainipulations.removeNonBreakingSpaceFromJobDetails();
        DomMainipulations.addFilterTextHeadingJobResults();
        DomMainipulations.showAuthorDetailsIfAuthor();
        SearchOverlay.handleSearchOverlay();
        CreateCarousels();
        Filters.scrollHandler($);
        Modal.closeModalOnBgClick();
        BannerApi.getBannerImages();
        HomepageSearch.moveLocationSearchField();
        HomepageSearch.handleSearchFilters();
        JobResults.initialise();
        JobFilters.initialise();
        Pagination.initialise();
        JobsNearYou.moveLocationSearchField();
        ListWidget.initialise();
        DomMainipulations.displayNoSavedJobsMessage();
        Cookie.CookieLinkCLickHandler();
        VacancyButtons.openApplyLinkInNewTab();

        $(document).on("job-filter-initialized", function () {
            (
                window as any
            ).jobFilterNoReloadController.enableDefaultFilterCounts();
        });
    }
});
